import React, { Fragment, useMemo } from "react"
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer"
import moment from "moment"
import logo from "../../../../../assets/images/crewmama_brand.png"

const styles = StyleSheet.create({
  headingSection: {
    marginBottom: 10,
    padding: 10,
  },
  logo: {
    width: 150,
    alignSelf: "flex-end",
  },
  headingCol: {
    width: "50%",
  },
  actionsSection: {
    marginBottom: 10,
    marginTop: 10,
    border: "1px solid #9A9A9A",
    borderRadius: "4px",
    padding: 10,
    minHeight: 100,
    width: 200,
  },
  headingTitle: {
    textTransform: "uppercase",
    color: "#00003D",
    opacity: "0.4",
    fontWeight: 800,
    fontSize: "11px",
  },
  boldText: {
    fontWeight: 800,
  },
})

const PdfHeader = ({ data = {}, type = "" }) => {
  const displayedType =
    type && type.toLowerCase() === "crew-bill" ? "Bill Approval" : "Deal Memo"

  const displayedCrewName =
    data && data.first_name
      ? `${data.first_name} ${data.last_name}`
      : "Unassigned"

  //hide Misc Expenses user that is for add expenses that are not attach to a crew
  const noDisplayCrew =
    data.first_name !== "Misc" && data.last_name !== "Expenses"

  const organizationLogo = useMemo(
    () => {
      if (data && data.company_id !== 2) {
        return (
          data &&
          data.company_logo_image &&
          JSON.parse(data.company_logo_image).url
        )
      } else {
        if (data && data.crewmama_or_gtt === "crewmama") {
          return logo
        } else {
          return null
        }
      }
    },
    [data]
  )
  const startDate =
    data && data.start_date
      ? moment(data.start_date).format("M/D/YYYY")
      : "Start Date N/A"

  return (
    <Fragment>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
          }}
        >
          <Text style={styles.headingTitle}>
            SHOOT ID:{" "}
            <Text style={{ color: "#000000", opacity: 1, fontSize: "10px" }}>
              {data && data.shoot_id}
            </Text>
          </Text>
          <Text style={styles.headingTitle}>
            SHOOT NAME:{" "}
            <Text
              style={{
                color: "#000000",
                opacity: 1,
                fontSize: "10px",
                textTransform: "none",
              }}
            >
              {data && data.shoot_name}
            </Text>
          </Text>
          <Text style={styles.headingTitle}>
            SHOOT DATE:{" "}
            <Text
              style={{
                color: "#000000",
                opacity: 1,
                fontSize: "10px",
                textTransform: "none",
              }}
            >
              {startDate}
            </Text>
          </Text>
        </View>
        {organizationLogo && (
          <Image style={styles.logo} src={organizationLogo} />
        )}
      </View>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: "15px",
        }}
      >
        {noDisplayCrew && (
          <View style={styles.headingCol}>
            <Text style={styles.headingTitle}>{displayedType} For: </Text>
            <Text>{displayedCrewName}</Text>
            <Text>{data.name}</Text>
          </View>
        )}
      </View>
    </Fragment>
  )
}

export default PdfHeader
